module.exports = __webpack_public_path__ + "static/media/工程咨询甲级资信-建筑、农林业、电力、电子、石化等@3x.a311ca52.png";